import { colors } from 'ui/theme/colors';
import { getColor } from '../../../utils';
import { SvgIcon, SvgIconProps } from '../../../SvgIcon';

export const InAppRecall24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.347 5H5.84C5.56385 5 5.34 5.22386 5.34 5.5V6.80399H18.9282V8.30399H5.34V18.7295C5.34 19.0056 5.56385 19.2295 5.84 19.2295H11.8437C12.2579 19.2295 12.5937 19.5653 12.5937 19.9795C12.5937 20.3937 12.2579 20.7295 11.8437 20.7295H5.84C4.73543 20.7295 3.84 19.8341 3.84 18.7295V5.5C3.84 4.39543 4.73543 3.5 5.84 3.5H19.347C20.4516 3.5 21.347 4.39543 21.347 5.5V11.3648C21.347 11.779 21.0113 12.1148 20.597 12.1148C20.1828 12.1148 19.847 11.779 19.847 11.3648V5.5C19.847 5.22386 19.6232 5 19.347 5ZM18.0103 14.661C18.2971 14.3622 18.2874 13.8874 17.9885 13.6006C17.6896 13.3138 17.2149 13.3236 16.9281 13.6224L13.0376 17.6764C12.7591 17.9666 12.7591 18.4248 13.0376 18.715L16.9281 22.769C17.2149 23.0679 17.6896 23.0777 17.9885 22.7909C18.2874 22.504 18.2971 22.0293 18.0103 21.7304L15.2827 18.8881C14.9114 18.5012 14.9114 17.8902 15.2827 17.5033L18.0103 14.661ZM21.8791 13.6006C22.178 13.8874 22.1878 14.3622 21.901 14.661L19.1733 17.5033C18.802 17.8902 18.802 18.5012 19.1733 18.8881L21.901 21.7304C22.1878 22.0293 22.178 22.504 21.8791 22.7909C21.5803 23.0777 21.1055 23.0679 20.8187 22.769L16.9282 18.715C16.6497 18.4248 16.6497 17.9666 16.9282 17.6764L20.8187 13.6224C21.1055 13.3236 21.5803 13.3138 21.8791 13.6006Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
